import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
    theme: {
        dark: true,
        options: {
            customProperties: true
        },
        themes: {
            light: {
                primary: '#B41322',
                secondary: '#4D4D4D',
                accent: '#481313',
                error: '#c11617',
                info: '#155ac7',
                success: '#0ba048',
                warning: '#ec7e13'
            },
            dark: {
                primary: '#B41322',
                secondary: '#4D4D4D',
                accent: '#481313',
                error: '#c11617',
                info: '#155ac7',
                success: '#0ba048',
                warning: '#ec7e13'
            }
        }
    },
    icons: {
        iconfont: 'mdi'
    }
})
